@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.home.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.home.generated.resources/"

internal val Res.string.feature_home_account_error: StringResource by lazy {
      StringResource("string:feature_home_account_error", "feature_home_account_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 78),
      ))
    }

internal val Res.string.feature_home_account_number: StringResource by lazy {
      StringResource("string:feature_home_account_number", "feature_home_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89, 51),
      ))
    }

internal val Res.string.feature_home_account_success: StringResource by lazy {
      StringResource("string:feature_home_account_success", "feature_home_account_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141, 72),
      ))
    }

internal val Res.string.feature_home_account_type: StringResource by lazy {
      StringResource("string:feature_home_account_type", "feature_home_account_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214, 49),
      ))
    }

internal val Res.string.feature_home_arrow_up: StringResource by lazy {
      StringResource("string:feature_home_arrow_up", "feature_home_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 264, 41),
      ))
    }

internal val Res.string.feature_home_coin_image: StringResource by lazy {
      StringResource("string:feature_home_coin_image", "feature_home_coin_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306, 39),
      ))
    }

internal val Res.string.feature_home_desc: StringResource by lazy {
      StringResource("string:feature_home_desc", "feature_home_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346, 145),
      ))
    }

internal val Res.string.feature_home_loading: StringResource by lazy {
      StringResource("string:feature_home_loading", "feature_home_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 492, 40),
      ))
    }

internal val Res.string.feature_home_mark_default: StringResource by lazy {
      StringResource("string:feature_home_mark_default", "feature_home_mark_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 533, 53),
      ))
    }

internal val Res.string.feature_home_no_account: StringResource by lazy {
      StringResource("string:feature_home_no_account", "feature_home_no_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 587, 59),
      ))
    }

internal val Res.string.feature_home_request: StringResource by lazy {
      StringResource("string:feature_home_request", "feature_home_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 702, 40),
      ))
    }

internal val Res.string.feature_home_request_money: StringResource by lazy {
      StringResource("string:feature_home_request_money", "feature_home_request_money", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 647, 54),
      ))
    }

internal val Res.string.feature_home_send: StringResource by lazy {
      StringResource("string:feature_home_send", "feature_home_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 791, 33),
      ))
    }

internal val Res.string.feature_home_send_money: StringResource by lazy {
      StringResource("string:feature_home_send_money", "feature_home_send_money", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 743, 47),
      ))
    }

internal val Res.string.feature_home_view_more: StringResource by lazy {
      StringResource("string:feature_home_view_more", "feature_home_view_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 825, 42),
      ))
    }

internal val Res.string.feature_home_wallet_balance: StringResource by lazy {
      StringResource("string:feature_home_wallet_balance", "feature_home_wallet_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 868, 55),
      ))
    }

internal val Res.string.home_filter_transactions: StringResource by lazy {
      StringResource("string:home_filter_transactions", "home_filter_transactions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 924, 60),
      ))
    }

internal val Res.string.home_no_transactions_found: StringResource by lazy {
      StringResource("string:home_no_transactions_found", "home_no_transactions_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 985, 94),
      ))
    }

internal val Res.string.home_see_all: StringResource by lazy {
      StringResource("string:home_see_all", "home_see_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1080, 32),
      ))
    }

internal val Res.string.home_transaction_history: StringResource by lazy {
      StringResource("string:home_transaction_history", "home_transaction_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1113, 60),
      ))
    }

internal val Res.string.start_sending_your_money_tax_free: StringResource by lazy {
      StringResource("string:start_sending_your_money_tax_free", "start_sending_your_money_tax_free", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 81),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_home_account_error", Res.string.feature_home_account_error)
  map.put("feature_home_account_number", Res.string.feature_home_account_number)
  map.put("feature_home_account_success", Res.string.feature_home_account_success)
  map.put("feature_home_account_type", Res.string.feature_home_account_type)
  map.put("feature_home_arrow_up", Res.string.feature_home_arrow_up)
  map.put("feature_home_coin_image", Res.string.feature_home_coin_image)
  map.put("feature_home_desc", Res.string.feature_home_desc)
  map.put("feature_home_loading", Res.string.feature_home_loading)
  map.put("feature_home_mark_default", Res.string.feature_home_mark_default)
  map.put("feature_home_no_account", Res.string.feature_home_no_account)
  map.put("feature_home_request", Res.string.feature_home_request)
  map.put("feature_home_request_money", Res.string.feature_home_request_money)
  map.put("feature_home_send", Res.string.feature_home_send)
  map.put("feature_home_send_money", Res.string.feature_home_send_money)
  map.put("feature_home_view_more", Res.string.feature_home_view_more)
  map.put("feature_home_wallet_balance", Res.string.feature_home_wallet_balance)
  map.put("home_filter_transactions", Res.string.home_filter_transactions)
  map.put("home_no_transactions_found", Res.string.home_no_transactions_found)
  map.put("home_see_all", Res.string.home_see_all)
  map.put("home_transaction_history", Res.string.home_transaction_history)
  map.put("start_sending_your_money_tax_free", Res.string.start_sending_your_money_tax_free)
}
